import {
  CommonListActions,
  DynamicTabsActions,
  TabStatusCountActions,
  TabsActionButtonsActions,
} from "./UserListingAction";

const initialState = {
  fields: [],
  dynamicTabs: [],
  tabs: [],
  actionsButton: [],
  tab: "ACTIVE",
};

const UserListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case CommonListActions.COMMON_LIST_SUCCESS:
      return {
        ...state,
        fields: action.payload.fields,
        tab: action.payload.tab,
      };
    case CommonListActions.UPDATE_TAB:
      return {
        ...state,
        tab: action.payload,
      };

    case DynamicTabsActions.DYNAMIC_TABS_SUCCESS:
      return { ...state, dynamicTabs: action.payload };
    case TabStatusCountActions.TAB_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        tabs: action.payload,
      };
    case TabsActionButtonsActions.TABS_ACTION_BUTTONS_SUCCESS:
      return {
        ...state,
        actionsButton: action.payload?.data?.ACTION_BUTTON_DTO,
      };
    case TabsActionButtonsActions.TABS_ACTION_BUTTONS_ERROR:
      return {
        ...state,
        actionsButton: [],
      };

    default:
      return state;
  }
};

export default UserListingReducer;
